/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Tema {
  constructor (funcionarioId) {


    this.funcionario_tema_id = uuidV4()
    this.funcionario_id = funcionarioId
    this.cor = ''
    this.opacidade = ''
    this.urls_imagem = []
    this.imagens = []
  }
}
